import { Card } from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import moment from "moment/min/moment-with-locales";
import { lineTrendOptions } from "../chartOptions";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function OverlapTrend({ data, loading, error, name }) {
    const chartData = useMemo(() => {
        if (data) {
            return {
                labels: data.trends.map(x => moment(x.basis_week).format("L")),
                datasets: [
                    {
                        type: "line",
                        data: data.trends.map(x => Math.round(x.common)),
                        datalabels: { formatter: value => value + "%" },
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className="text-center">{name}</Card.Header>
            <Card.Body className="card-dashboard-music-chart d-flex justify-content-center align-items-center">
                {loading ? (
                    <LoadingIndicator width={75} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    data && <Chart data={chartData} options={lineTrendOptions} />
                )}
            </Card.Body>
        </Card>
    );
}
